import { useTranslation } from "react-i18next";

import { Mascot } from "../components/Mascot";
import { MASCOTS } from "../components/mascots";
import { useHasKey } from "../components/useHasKey";

/**
 * The open-source entry is not a plain FAQ key: it lives under `openSource.pledge` because
 * the claims gate exempts exactly that key from the "open source" ban, and the exemption is
 * recorded per key+phrase in the matrix. Renaming it silently re-arms the gate.
 */
const ITEMS = [
  { key: "faq.price", question: "faq.price.question", answer: "faq.price.answer" },
  { key: "openSource", question: "openSource.pledge.title", answer: "openSource.pledge.body" },
  { key: "faq.phrase", question: "faq.phrase.question", answer: "faq.phrase.answer" },
  { key: "faq.reach", question: "faq.reach.question", answer: "faq.reach.answer" },
  { key: "faq.verify", question: "faq.verify.question", answer: "faq.verify.answer" },
  { key: "faq.devices", question: "faq.devices.question", answer: "faq.devices.answer" },
  { key: "faq.ads", question: "faq.ads.question", answer: "faq.ads.answer" },
] as const;

export function Faq() {
  const { t } = useTranslation();
  const has = useHasKey();

  const items = ITEMS.filter((item) => has(item.question));

  if (items.length === 0) return null;

  return (
    <section className="section" id="faq">
      <div className="section__intro">
        <div className="section__head">
          <span className="section__eyebrow">08</span>
          <h2 className="section__heading">{t("faq.heading")}</h2>
        </div>

        {/* This head is a heading and nothing else — the emptiest block on the page — and the
            lightest in tone, which is what the wink is for. */}
        <Mascot mascot={MASCOTS.wink} />
      </div>

      <div className="faq">
        {items.map((item) => (
          // <details> again: it opens without hydration and is keyboard-operable for free.
          <details className="faq__item" key={item.key}>
            <summary className="faq__question">{t(item.question)}</summary>
            <p className="faq__answer">{t(item.answer)}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
